module.exports = __webpack_public_path__ + "static/media/maurice-memoji-cropped.c4dd10b2.png";